"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.4 20.4",
    width: "74.4",
    height: "20.4"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#EC6833",
    d: "M58,15"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M23.2,20.4c-1.7,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2S24.9,20.4,23.2,20.4z M23.2,15.1 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S24.4,15.1,23.2,15.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3.9,17.7H0.5c-0.3,0-0.5-0.2-0.5-0.5V9.9c0-0.1,0.1-0.3,0.1-0.4L2.8,7L6.1,1c0.1-0.2,0.3-0.3,0.4-0.3h6 C12.8,0.8,13,1,13,1.3s-0.2,0.5-0.5,0.5H6.8L3.6,7.5c0,0-0.1,0.1-0.1,0.1L1,10.1v6.6h2.9c0.3,0,0.5,0.2,0.5,0.5S4.2,17.7,3.9,17.7 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#E75112",
    d: "M3.9,17.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M20.5,17.7H9.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h11.3c0.3,0,0.5,0.2,0.5,0.5S20.8,17.7,20.5,17.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M5.8,8.4c-0.1,0-0.2,0-0.2-0.1C5.4,8.2,5.3,7.9,5.4,7.7l2-4c0.1-0.2,0.3-0.3,0.4-0.3h2 c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H8.1L6.3,8.1C6.2,8.3,6,8.4,5.8,8.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M12.5,17.3c-0.3,0-0.5-0.2-0.5-0.5V1.3c0-0.3,0.2-0.5,0.5-0.5S13,1,13,1.3v15.5C13,17,12.8,17.3,12.5,17.3 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M12.5,15.1h-12c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h12c0.3,0,0.5,0.2,0.5,0.5S12.8,15.1,12.5,15.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M6.6,20.4c-1.7,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2S8.3,20.4,6.6,20.4z M6.6,15.1 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S7.8,15.1,6.6,15.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M73.9,16.4h-5.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.7V1H17.2v10.9h11.6c0.3,0,0.5,0.2,0.5,0.5v3h16 c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H28.8c-0.3,0-0.5-0.2-0.5-0.5v-3H16.7c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5 h57.2c0.3,0,0.5,0.2,0.5,0.5v15.4C74.4,16.2,74.2,16.4,73.9,16.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M57,20.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S58.7,20.3,57,20.3z M57,15 c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3s2.3-1,2.3-2.3S58.2,15,57,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M64.5,20.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S66.2,20.3,64.5,20.3z M64.5,15 c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3s2.3-1,2.3-2.3S65.7,15,64.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M49.5,20.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S51.2,20.3,49.5,20.3z M49.5,15 c-1.2,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3s2.3-1,2.3-2.3S50.8,15,49.5,15z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "56.5",
    cy: "7.8",
    r: "4.6"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "31.6",
    y: "0.3",
    fill: "#EC6833",
    width: "1",
    height: "16"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "38.6",
    y: "0.3",
    fill: "#EC6833",
    width: "1",
    height: "16"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "68.6",
    y: "0.3",
    fill: "#EC6833",
    width: "1",
    height: "16"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "23.6",
    y: "0.3",
    fill: "#EC6833",
    width: "1",
    height: "12"
  }));
};

exports["default"] = _default;